import { InjectionToken } from '@angular/core';

export const streetTypes = [
  {
    code: 'AV',
    name: 'Avenida',
  },
  {
    code: 'CL',
    name: 'Calle',
  },
  {
    code: 'CM',
    name: 'Camino',
  },
  {
    code: 'CR',
    name: 'Carretera',
  },
  {
    code: 'GL',
    name: 'Glorieta',
  },
  {
    code: 'KM',
    name: 'Kilómetro',
  },
  {
    code: 'PG',
    name: 'Polígono',
  },
  {
    code: 'PS',
    name: 'Paseo',
  },
  {
    code: 'PZ',
    name: 'Plaza',
  },
  {
    code: 'RD',
    name: 'Ronda',
  },
  {
    code: 'VI',
    name: 'Vía',
  },
] as const;

export type StreetTypes = typeof streetTypes;

export const STREET_TYPES = new InjectionToken('STREET_TYPES', {
  providedIn: 'root',
  factory: () => streetTypes,
});
